import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api.ts';
import { Alert, Spinner, TextField } from '../components/ui.tsx';

export default function Forgot() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.forgot(email.trim());
      setSent(true);
    } catch {
      setError('Non riesco a contattare il server. Riprova quando torna la rete.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="content narrow">
      <div className="stack">
        <h1>Password dimenticata</h1>
        {sent ? (
          <>
            {/* Deliberately the same message whether or not the address is registered. */}
            <Alert kind="info">Se quell’indirizzo ha un account, ora ha anche un link per reimpostare la password. Vale un’ora.</Alert>
            <p className="center"><Link to="/login">Torna al login</Link></p>
          </>
        ) : (
          <form className="stack" onSubmit={submit} noValidate>
            {error && <Alert kind="error">{error}</Alert>}
            <TextField id="email" label="Email" type="email" inputMode="email" autoComplete="username" required
              value={email} onChange={(e) => setEmail(e.target.value)} />
            <button className="btn block" type="submit" disabled={busy}>{busy ? <Spinner /> : 'Mandami il link'}</button>
            <p className="center"><Link to="/login">Torna al login</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
